<template lang="pug">
	.creative-services-manager--param-editor.flex-col.space
		StructureCriteria(ref="criteria", :paramsResolver="paramsResolver", :params="tag.params", :paramsCaptions="tag.paramsCaptions", :associations="associations", :service="service", :hideCriteria="true", @change="onCriteriaChange", 
			:usedServices="usedServices", @template-field-change="onTemplateFieldChange", :allowTemplateFieldCreation="allowTemplateFieldCreation", @action="(action, param, item) => $emit('action', action, param, item)")
		UsedServicesContextMenu(:servicesTextSource="tag.insertion.Ssml", :templateFields="supportedTemplateFields", :associatedTemplateField="associations && associations[param.param.Name]",
			:excludeServicesIds="[service.Oid]", @menu-items-change="onUsedServicesItemsChange", :hideUI="true", :forceTemplateFields="allowTemplateFieldCreation")
		.lr-padding.flex-col.space
			DxRadioGroup(:items="replaceOptions", valueExpr="id", displayExpr="text", :value.sync="selectedReplaceOption")
			.flex-row.space.align-center(v-if="selectedReplaceOption !== 'value'")
				.font-small {{$tCaption('Occurences')}}: {{occurrences.length}}
				fas.grey.clickable.hoverable.info-icon(icon="info-circle", @click="toggleWithAnimationOptionsVisible", @mouseenter="toggleWithAnimationOptionsVisible(true)", @mouseleave="toggleWithAnimationOptionsVisible(false)")
				DxPopover(:visible="withAnimationOptionsVisible" :animation="animationConfig" target=".info-icon" position="right")
					.flex-col.space.creative-services-manager
						.occurence.font-small.nowrap(v-for="occurrence in occurrences", v-html="getOccurenceInfo(occurrence)")
</template>

<script>
	import Loader from 'app-core/Loader.vue';
	import _ from 'lodash';
	import StructureCriteria from 'view/webServiceCaller/StructureCriteria.vue';
	import DxRadioGroup from 'devextreme-vue/radio-group';
	import { DxPopover } from 'devextreme-vue/popover';
	import serviceHelper from 'view/webServiceCaller/service-helper';
	import UsedParameterSelector from 'view/webServiceCaller/UsedParameterSelector.vue';
	import storage from 'storage';
	import UsedServicesContextMenu from 'view/insertion/UsedServicesContextMenu.vue';
	import creativeServicesHelper from './creative-services-helper';

	export default {
		translationCategory: 'creative.CreativeServicesManager',
		name: 'creative-services-manager--param-editor',
		components: { Loader, StructureCriteria, DxRadioGroup, DxPopover, UsedServicesContextMenu, UsedParameterSelector },
		props: ['tag', 'param', 'service', 'servicesStructure', 'templateFields', 'allowTemplateFieldCreation'],
		data() {
			return {
				replaceOptions: [
					{
						id: 'value',
						text: this.$tCaption('Replace specified value')
					},
					{
						id: 'insertion',
						text: this.$tCaption('Replace all occurrences (current insertion only)')
					},
					{
						id: 'service',
						text: this.$tCaption('Replace all occurrences (same service)')
					},
					{
						id: 'param',
						text: this.$tCaption('Replace all occurrences (same param name)')
					}
				],
				selectedReplaceOptionValue: storage.prop('servicesManager_selectedReplaceOption', void 0, 'insertion'),
				animationConfig: {
					show: {
						type: 'pop',
						from: {
							scale: 0,
						},
						to: {
							scale: 1,
						},
					},
					hide: {
						type: 'fade',
						from: 1,
						to: 0,
					},
				},
				withAnimationOptionsVisible: false,
				usedServices: null,
				associations: _.cloneDeep(this.tag.associations || {})
			};
		},
		computed: {
			isComplex() {
				return this.param?.isComplex;
			},
			supportedTemplateFields() {
				return this.param?.param && this.templateFields.filter(f => serviceHelper.isSupportedTemplateFieldForParam(f, this.param.param, this.param.isComplex)) || [];
			},
			selectedReplaceOption: {
				get: function() { return this.selectedReplaceOptionValue.value },
				set: function(v) { this.selectedReplaceOptionValue.value = v }
			},
			occurrences() {
				return creativeServicesHelper.getOccurrences(this.param.param, this.tag, this.service, this.servicesStructure, this.selectedReplaceOption);
			},
			occurrencesHint() {
				return this.occurrences.map(f => this.getOccurenceInfo(f)).join('\r\n');
			}
		},
		mounted() {
			if (__DEBUG__)
				window.creativeServicesManagerParamEditor = this;
		},
		methods: {
			onUsedServicesItemsChange(e) {
				this.usedServices = e.all;
			},
			onTemplateFieldChange(param, templateFieldId) {
				if (__DEBUG__)
					console.debug('onTemplateFieldChange', { param, templateFieldId });
				if (this.associations[param.Name] === templateFieldId) {
					delete this.associations[param.Name];
				} else {
					this.$set(this.associations, param.Name, templateFieldId);
				}
				this.$emit('associations-change', this.associations);
			},
			async onCriteriaChange(criteria, params, paramsCaptions, propagatedEditableParams) {
				const resParams = {};
				const resParamsCaptions = {};
				const param = this.param.param;

				const editableParams = await serviceHelper.getParentEditableParameters(param);

				const set = (name) => {
					resParams[name] = params[name];
					if (paramsCaptions[name])
						resParamsCaptions[name] = paramsCaptions[name];
				}

				if (this.param.isComplex) {
					param.Keys?.map(key => set(`${param.Name}_${key}`));
				} else {
					if (editableParams)
						editableParams.map(f => set(`${f}`));
					set(`${param.Name}`);
				}

				this.$emit('change', resParams, resParamsCaptions);
			},
			toggleWithAnimationOptionsVisible(forced) {
				this.withAnimationOptionsVisible = forced !== void 0 ? forced : !this.withAnimationOptionsVisible;
			},
			getOccurenceInfo(f) {
				return `${this.getTime(f.insertion.StartTime)}, ${f.tag.insertionText}`;
			},
			paramsResolver(params, isComplex) {
				if (__DEBUG__)
					console.debug('Params resolver', { params, isComplex, name: this.param.name });
				return params?.filter(f => f.Name === this.param.name);
			},
			getTime(secs) {
				return this.$moment.utc(secs).format(secs > 360000 ? 'HH:mm:ss' : 'mm:ss');
			},
		}
	};
</script>
<style lang='scss'>
	@import "main/themes/generated/variables.base.scss";
	.creative-services-manager--param-editor {
		.rgroup {
			margin-left: 20px;
		}
	}
</style>
